import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const sMServicesApi = createApi({
  reducerPath: 'sMServicesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Service'],
  endpoints: builder => ({
    getServices: builder.query({
      query: (params) => ({
        url: `/services/`,
        params,
      }),
      providesTags: ['Service'],
    }),
    getServiceById: builder.query({
      query: id => `/services/${id}/`,
      providesTags: (result, error, id) => [{ type: 'Service', id }],
    }),
    createService: builder.mutation({
      query: body => ({
        url: '/services/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Service'],
    }),
    updateService: builder.mutation({
      query: ({ id, body }) => ({
        url: `/services/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Service'],
    }),
    patchService: builder.mutation({
      query: ({ id, body }) => ({
        url: `/services/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Service'],
    }),
  }),
});

export const {
  useGetServicesQuery,
  useLazyGetServicesQuery,
  useGetServiceByIdQuery,
  useCreateServiceMutation,
  useUpdateServiceMutation,
  usePatchServiceMutation,
} = sMServicesApi;